import React from 'react';
import { Navigate } from 'react-router-dom';

const ClientRoute = ({ element: Component, ...rest }) => {
  const authToken = localStorage.getItem('authToken');
  const role = localStorage.getItem('role');
  
  // Check if user is authenticated and has client role
  if (!authToken) {
    return <Navigate to="/login" replace />;
  }
  
  // Allow client, admin, and superadmin roles to access client dashboard
  if (role && ['client', 'admin', 'superadmin'].includes(role)) {
    return Component;
  }
  
  // Redirect to appropriate dashboard based on role
  if (role == 'admin' || role == 'superadmin') {
    return <Navigate to="/dashboard" replace />;
  }
  
  // Default redirect if no valid role
  return <Navigate to="/" replace />;
};

export default ClientRoute;